export class ExtraStopChangeApiModel {
    rootSequence: number = -1;
    sequenceNumber: number = -1;
    deliveryNumber: string = '';
    city: string = '';
    postalCode: string = '';
    countryCode: string = '';
    loadingUnloadingMinutes: string = '';
}
